import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useStructureContext } from "./Providers/StructureProvider";

const DiverseIcon = ({
  count = 0,
  variant,
  size = 22,
  bgColor,
  className = "",
  ariaLabel = "diversity icon",
  tipPlacement = "auto",
  group,
  disabled = false,
  setShowDiverseModal,
}) => {
  const { setHighlightData } = useStructureContext();

  let dynamicBgColor = bgColor;
  let diversityStatus = "";

  if (!group?.reporting) {
    dynamicBgColor = "grey";
    diversityStatus = "Reporting Off";
  } else {
    switch ((variant || "").toLowerCase()) {
      case "full":
        dynamicBgColor = "green";
        diversityStatus = "Full Diversity";
        break;
      case "partial":
        dynamicBgColor = "orange";
        diversityStatus = "Partial Diversity";
        break;
      default:
        dynamicBgColor = "red";
        diversityStatus = "No Diversity";
    }
  }

  const tooltipText = group?.name
    ? `${group.name} | ${diversityStatus}`
    : diversityStatus;

  const circleStyle = {
    width: size,
    height: size,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: dynamicBgColor,
    fontSize: Math.round(size * 0.45),
  };

  const containerStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
  };

  // const numberStyle = {
  //   color: "#ffffff",
  //   fontWeight: 700,
  //   fontSize: Math.round(size * 0.45),
  //   lineHeight: 1,
  //   fontFamily:
  //     "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
  // };

  return (
    <>
      <div
        className={className}
        style={containerStyle}
        onClick={() => !disabled && setShowDiverseModal?.((prev) => !prev)}
        onMouseEnter={() =>
          !disabled &&
          setHighlightData({
            groupId: group?.id,
            color: dynamicBgColor,
          })
        }
        onMouseLeave={() => !disabled && setHighlightData(null)}
      >
        <OverlayTrigger
          placement={tipPlacement}
          overlay={<Tooltip>{tooltipText}</Tooltip>}
        >
          <div
            role="img"
            aria-label={`${ariaLabel}: ${count}`}
            style={{
              ...circleStyle,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span style={{ color: "#fff", fontWeight: 500, fontSize: 14 }}>
              {count}
            </span>
          </div>
        </OverlayTrigger>
      </div>
    </>
  );
};

export default DiverseIcon;
